// this file is generated by 'scripts/generate-configs'
export const HASH = 'ce50a063';
